export default __webpack_public_path__ + "static/media/person_sobre_recortado.1acef7ea.png";